<template>
  <read-more
    class="block-tekst"
    :more-str="readMoreText"
    :less-str="readLessText"
    :text="content"
    :max-chars="value.Collapse ? 700 : 1000000"
    link="#"
  />
</template>

<script>
import Renderer from "./mixin";

export default {
  computed: {
    content() {
      if (this.$i18n.locale == "no") {
        return this.$md.render(this.Innhold);
      } else {
        return this.$md.render(this.Innhold_eng);
      }
    },
    readMoreText() {
      if (this.$i18n.locale == "no") {
        return "Les mer";
      } else {
        return "Read more";
      }
    },
    readLessText() {
      if (this.$i18n.locale == "no") {
        return "Skjul";
      } else {
        return "Hide";
      }
    },
  },
  mixins: [Renderer(["Innhold", "Innhold_eng"])],
};
</script>

<style lang="scss">
.block-tekst {
  a {
    color: #9678f4;
  }
  a:hover {
    opacity: 0.6;
  }
  max-width: 800px;
  span a {
    display: block;
    max-width: 100px;
    margin-top: 2em;
    margin-bottom: 4em;
    color: white;
    padding: 10px;
    background: #9678f4;
    text-align: center;
    text-decoration: none;

    &:hover {
      background: #8669df;
    }
  }
}
</style>
